const BucketType = {
  Organisation: 1,
  Apprentice: 2,
  Employee: 3,
  Jobseeker: 4,
  Caseworker: 5,
  UserCertifications: 6,
  PerformanceReview: 7,
  WioaChecklist: 8
};

export default BucketType;
